var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FeatureFlagUserBuilder, featureFlagUserIdentify } from '@raisin/feature-flag-react-client';
import { isMobileApp, isMobileView } from './mobileApp';
import { isCSR } from './domain';
import { getFeatureFlagClient } from './featureFlag';
export const DEVICE_TYPE = {
    MOBILE: 'mobile',
    DESKTOP: 'desktop',
};
export const generateUniqueKey = () => `device-${crypto.randomUUID()}`;
export const createAnonymousContext = () => {
    if (!isCSR())
        return null;
    const isMobile = isMobileApp() || isMobileView();
    const anonymousKey = generateUniqueKey();
    return new FeatureFlagUserBuilder(anonymousKey)
        .createAnonymousDeviceContext(anonymousKey, isMobile ? DEVICE_TYPE.MOBILE : DEVICE_TYPE.DESKTOP)
        .build();
};
export const storeAnonymousContextInLocalStorage = (anonymousContext) => {
    try {
        localStorage.setItem('anonymousContext', JSON.stringify(anonymousContext));
    }
    catch (error) {
        console.error('Error storing anonymous context in localStorage:', error);
    }
};
export const getAnonymousContextFromLocalStorage = () => {
    if (!isCSR())
        return null;
    const anonymousContext = localStorage.getItem('anonymousContext');
    return anonymousContext ? JSON.parse(anonymousContext) : null;
};
export const sendAnonymousContextToLD = (anonymousContext) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const client = yield getFeatureFlagClient();
        yield featureFlagUserIdentify(client, anonymousContext);
    }
    catch (error) {
        console.error('Failed to send Anonymous context to Launch Darkly.', error);
    }
});
export const initializeAnonymousContext = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!isCSR())
        return null;
    let anonymousContext = getAnonymousContextFromLocalStorage();
    if (!anonymousContext) {
        anonymousContext = createAnonymousContext();
        try {
            storeAnonymousContextInLocalStorage(anonymousContext);
            yield sendAnonymousContextToLD(anonymousContext); // Send it to LD
        }
        catch (error) {
            console.warn(error);
        }
    }
    return anonymousContext;
});
export const createAuthenticatedUserContext = (bacNumber, countryCode) => {
    if (!isCSR())
        return null;
    return new FeatureFlagUserBuilder(bacNumber)
        .country(countryCode)
        .investorStatus('web-investor')
        .build();
};
export const setUpFeatureFlagUserIdentify = (anonymousContext, userContext) => __awaiter(void 0, void 0, void 0, function* () {
    const multiContext = {
        kind: 'multi',
        user: userContext,
        device: anonymousContext,
    };
    try {
        const client = yield getFeatureFlagClient();
        yield featureFlagUserIdentify(client, multiContext);
    }
    catch (error) {
        console.error('Failed to initialise Feauture flag User Identity.', error);
    }
});
//# sourceMappingURL=multiContext.js.map